import * as R from 'ramda'
export const ProducerType = {
  PRODUCER: 'Producer',
  CSR: 'CSR'
}
export const producerTypeKeys = R.keys(ProducerType)
export const producerTypeValues = R.values(ProducerType)
